import React, { Fragment, useEffect } from "react";
import { Button } from "reactstrap";
import { useSupporterSignUpContext } from "../context/SupporterStatusContext";
import animationLogo from "../../../assets/utils/images/animetion_logo.gif";

import { useMutation } from "@apollo/client";
import {
  CREATE_SUPPORTER,
  UPDATE_SUPPORTER,
} from "../mutation/createSupporter";

import { useApolloClient } from "@apollo/client";
import { CHECK_USER_STATUS } from "../../../queries";

const Step4 = ({ update = false, setFreezeModal }) => {
  const { dispatch, state } = useSupporterSignUpContext();
  const client = useApolloClient();

  const [createSupporter, { loading: createLoading, error: createError }] =
    useMutation(CREATE_SUPPORTER);

  const [updateSupporter, { loading: updateLoading, error: updateError }] =
    useMutation(UPDATE_SUPPORTER);

  const doCreateSupporter = async () => {
    try {
      setFreezeModal(true);
      await createSupporter({
        variables: {
          entityNumber: state.entityNumber,
          entityForm: state.entityForm,
          name: state.name,
          nameKana: state.nameKana,
          representativeName: state.representativeName,
          incorporationDate: state.incorporationDate,
          prefecture: state.prefecture,
          city: state.city,
          phoneNumber: state.phoneNumber,
          industry: state.industry,
          mission: state.mission,
          sustainabilityPolicy: state.sustainabilityPolicy,
          collaborationExperienceTime: state.collaborationExperienceTime,
          collaborationNeeds: state.collaborationNeeds.map((item) =>
            Number(item)
          ),
          focusedSdges: state.focusedSdges,
          focusedStakeholders: state.focusedStakeholders,
          interestingCountry: state.interestingCountry.map((country) => {
            return country.id;
          }),
          interestingActivity: state.interestingActivity,
        },
        onCompleted: async (data) => {
          console.log(data);
          // alert("登録が完了しました。");
          await client.refetchQueries({
            include: [CHECK_USER_STATUS],
          });
        },
      });
    } catch (error) {
      alert(error);
      alert("入力内容に誤りがあります");
    } finally {
      setFreezeModal(false);
    }
  };

  const doUpdateSupporter = async () => {
    try {
      await updateSupporter({
        variables: {
          mission: state.mission,
          sustainabilityPolicy: state.sustainabilityPolicy,
          collaborationExperienceTime: state.collaborationExperienceTime,
          collaborationNeeds: state.collaborationNeeds.map((item) =>
            Number(item)
          ),
          focusedSdges: state.focusedSdges,
          focusedStakeholders: state.focusedStakeholders,
          interestingCountry: state.interestingCountry.map((country) => {
            return country.id;
          }),
          interestingActivity: state.interestingActivity,
        },
        onCompleted: async (data) => {
          console.log(data);
          // alert("登録が完了しました。");
          await client.refetchQueries({
            include: [CHECK_USER_STATUS],
          });
        },
      });
    } catch (error) {
      alert(error);
      alert("入力内容に誤りがあります");
    }
  };

  useEffect(() => {
    if (update) {
      doUpdateSupporter();
      return;
    }
    doCreateSupporter();
  }, [update]);

  return (
    <Fragment>
      <div className="form-wizard-content">
        <div className="no-results">
          {(createLoading || updateLoading) && (
            <div
              style={{
                marginTop: "50px",
                marginBottom: "50px",
              }}
            >
              <img
                style={{ width: "80px", margin: "auto" }}
                src={animationLogo}
              ></img>
            </div>
          )}
          {!createLoading && !createError && (
            <>
              <div className="sa-icon sa-success animate">
                <span className="sa-line sa-tip animateSuccessTip" />
                <span className="sa-line sa-long animateSuccessLong" />
                <div className="sa-placeholder" />
                <div className="sa-fix" />
              </div>
              <div className="results-subtitle mt-4">登録が完了しました。</div>
              <div className="mt-3 mb-3" />
              <div className="text-center">
                <Button
                  color="success"
                  size="lg"
                  className="btn-shadow btn-wide"
                  onClick={() => {
                    // reload page
                    window.location.reload();
                  }}
                >
                  トップページへ
                </Button>
              </div>
            </>
          )}
        </div>
      </div>
    </Fragment>
  );
};
export default Step4;
